import { tss } from 'tss-react/mui';

const useStyles = tss.create(({ theme }) => ({
  sourceInfoBlockGridWrapper: {
    alignContent: 'start',
    paddingTop: '1rem'
  },
  sourceInfoBlockWrapper: {
    border: `1px solid ${theme.vars.palette.border.light}`,
    borderRadius: '.25rem'
  },
  sourceInfoBlockTitleInfoIcon: {
    color: theme.vars.palette.primary.main,
    marginRight: '.25rem'
  },
  supportedLogSourcesList: {
    paddingTop: '1rem',
    paddingBottom: '1rem'
  },
  sourceInfoBlockFooterText: {
    color: 'var(--mui-palette-Alert-infoColor)'
  },
  sourceInfoBlockFooterInfoIcon: {
    color: 'var(--mui-palette-Alert-infoIconColor)',
    marginRight: '.25rem'
  },
  sourceInfoBlockAccordionDetails: {
    maxHeight: '7rem',
    overflow: 'auto',
    borderTop: `1px solid ${theme.vars.palette.divider}`,
    borderBottom: `1px solid ${theme.vars.palette.border.light}`,
    '& *': {
      fontWeight: 'normal !important'
    }
  },
  sourceInfoBlockPanelAccordion: {
    background: 'none',
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    }
  },
  sourceInfoBlockPanelAccordionSummary: {
    backgroundColor: theme.vars.palette.background.elevation1,
    boxShadow: 'none',
    minHeight: '3rem',
    borderRadius: '.25rem',
    fontWeight: 600,
    width: '100%',
    '&.Mui-expanded': {
      minHeight: '3rem' // stop growing when expanded
    },
    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
      margin: 0 // reset margin
    },
    '& .MuiAccordionSummary-content.Mui-expanded': {
      margin: 0 // stop shifting
    }
  }
}));

export default useStyles;
